// 渠道信息图表配置
import { UNIFIED_TOOLTIP_STYLE } from '../../../configs/tooltipCommon';
export var CHANNEL_INFO_CHART_SETTINGS = {
    grid: {
        left: 60,
        right: 60,
        top: 24,
        bottom: 0,
    },
    smooth: false,
    tooltip: UNIFIED_TOOLTIP_STYLE,
};
